// src/pages/LandingPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css'; // We'll create this CSS file next

function LandingPage() {
  return (
    <div className="landing-container">
      <header className="landing-header">
        <h1>Welcome to CheckMenus</h1>
        <p className="landing-intro-text">Step into the future of dining! Effortlessly convert your restaurant's paper menus to stunning digital versions using our smart AI. Manage everything online, offer seamless table ordering, and delight your customers. It's the simple way for any restaurant to modernize and thrive.</p>
      </header>
      
      <main className="landing-main">
        <section className="hero-section">
          <h2>Go digital in minutes!</h2>
          <p>
            Use AI to instantly convert your paper menus, manage them online, and offer convenient table ordering. The easy way for any restaurant to modernize.
          </p>
          <Link to="/home" className="cta-button">
            Get Started Now
          </Link>
        </section>

        <section className="features-section">
          <h2>Why Choose CheckMenus?</h2>
          <div className="features-grid">
            <div className="feature-item">
              <i className="fas fa-edit"></i>
              <h3>Easy Editing</h3>
              <p>Intuitive interface for quick menu updates.</p>
            </div>
            <div className="feature-item">
              <i className="fas fa-share-alt"></i>
              <h3>Simple Sharing</h3>
              <p>Share via link or QR code instantly.</p>
            </div>
            <div className="feature-item">
              <i className="fas fa-mobile-alt"></i>
              <h3>Mobile Friendly</h3>
              <p>Perfectly responsive on all devices.</p>
            </div>
            <div className="feature-item">
              <i className="fas fa-palette"></i>
              <h3>Customizable</h3>
              <p>Tailor the look to match your brand.</p>
            </div>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <p>&copy; {new Date().getFullYear()} CheckMenus. All rights reserved.</p>
        <p>
          <Link to="/create">Create New Menu</Link> | <Link to="/home">Login</Link>
        </p>
      </footer>
    </div>
  );
}

export default LandingPage;